module.exports = __webpack_public_path__ + "static/img/9.9231a6a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/3/sp/9.png
// module id = /VQG
// module chunks = 0